function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  margin: var(--theme-spacing-lg, 24px) 0;\n  border: 1px solid var(--vscode-editorWidget-border, var(--theme-border));\n  border-radius: var(--theme-radius-md, 8px);\n  overflow: hidden;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  margin: 0;\n  padding: var(--theme-spacing-md, 16px);\n  background: var(--vscode-editor-background, var(--theme-paper));\n  border-bottom: 1px solid var(--vscode-editorWidget-border, var(--theme-border));\n  font-size: var(--theme-typography-font-size-base, 1rem);\n  font-weight: var(--theme-typography-font-weight-semibold, 600);\n  color: var(--vscode-editor-foreground, var(--theme-text));\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  \n  @media (max-width: 768px) {\n    grid-template-columns: 1fr;\n  }\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  \n  &:first-of-type {\n    border-right: 1px solid var(--vscode-editorWidget-border, var(--theme-border));\n  }\n  \n  @media (max-width: 768px) {\n    &:first-of-type {\n      border-right: none;\n      border-bottom: 1px solid var(--vscode-editorWidget-border, var(--theme-border));\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  background: var(--vscode-editor-background, var(--theme-paper));\n  border: 1px solid var(--vscode-editorWidget-border, var(--theme-border));\n  padding: 4px 8px;\n  border-radius: var(--theme-radius-sm, 4px);\n  font-size: var(--theme-typography-font-size-xs, 0.75rem);\n  font-weight: var(--theme-typography-font-weight-medium, 500);\n  color: var(--vscode-descriptionForeground, var(--theme-text-secondary));\n  z-index: 10;\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  > div {\n    margin: 0;\n    border-radius: 0;\n    border: none;\n  }\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
import React from 'react';
import styled from '@emotion/styled';
var Container = styled.div(_templateObject());
var Title = styled.h4(_templateObject1());
var CompareContainer = styled.div(_templateObject2());
var CodePane = styled.div(_templateObject3());
var PaneLabel = styled.div(_templateObject4());
var StyledCodeBlock = styled.div(_templateObject5());
var CodeCompare = function(param) {
    var title = param.title, left = param.left, right = param.right;
    return /*#__PURE__*/ React.createElement(Container, null, title && /*#__PURE__*/ React.createElement(Title, null, title), /*#__PURE__*/ React.createElement(CompareContainer, null, /*#__PURE__*/ React.createElement(CodePane, null, /*#__PURE__*/ React.createElement(PaneLabel, null, left.label), /*#__PURE__*/ React.createElement(StyledCodeBlock, null, /*#__PURE__*/ React.createElement(CustomCodeBlock, {
        className: "language-".concat(left.language)
    }, left.code))), /*#__PURE__*/ React.createElement(CodePane, null, /*#__PURE__*/ React.createElement(PaneLabel, null, right.label), /*#__PURE__*/ React.createElement(StyledCodeBlock, null, /*#__PURE__*/ React.createElement(CustomCodeBlock, {
        className: "language-".concat(right.language)
    }, right.code)))));
};
export default CodeCompare;
